import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { HardHat } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1646227655685-a530813759b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODUwNjgzOTF8MA&ixlib=rb-4.1.0&q=85";

export default function AuthShell({ children }) {
  const { t, logo } = useLang();
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="relative hidden bg-secondary lg:block">
        <img src={HERO} alt="" className="h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary via-secondary/70 to-transparent" />
        <div className="absolute bottom-0 p-12">
          <Link to="/" className="flex items-center gap-2">
            {logo ? (
              <img src={logo} alt={t("brand")} className="h-14 w-auto max-w-[240px] object-contain" />
            ) : (
              <>
                <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-primary text-white"><HardHat className="h-5 w-5" /></span>
                <span className="font-head text-2xl font-extrabold text-white">{t("brand")}</span>
              </>
            )}
          </Link>
          <p className="mt-4 max-w-sm font-head text-2xl font-bold leading-snug text-white">{t("hero_title")}</p>
        </div>
      </div>
      <div className="flex items-center justify-center bg-slate-50 px-6 py-12">
        <div className="w-full max-w-sm">
          <Link to="/" className="mb-8 flex items-center gap-2 lg:hidden">
            {logo ? (
              <img src={logo} alt={t("brand")} className="h-11 w-auto max-w-[200px] object-contain" />
            ) : (
              <>
                <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-primary text-white"><HardHat className="h-5 w-5" /></span>
                <span className="font-head text-xl font-extrabold text-secondary">{t("brand")}</span>
              </>
            )}
          </Link>
          {children}
        </div>
      </div>
    </div>
  );
}
